/*LIBRARY*/
import { connect, useDispatch } from "react-redux";

/*COMPONENT*/
import PARENT_SINI from "../sini_v2/PARENT_SINI";
import SITE_SELECTION from "../site_selection/SITE_SELECTION";
import BLOCKED from "../sini_data/BLOCKED";

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/
import { is_user_get_access_by_license_key } from "../../App/actions/filter_license";

/*DATA*/

/*CONST*/

const SINI_WRAPER = ({ set_value_properties, properties }) => {
  const menuList = ["Site Selection", "Site Analysis"];
  const dispatch = useDispatch();

  const on_set_menu = (dt) => {
    set_value_properties({
      key: "sini_data_mode",
      value: dt,
    });
  };

  const { sini_data_mode } = properties;

  //local storage

  //local state

  // **Find the index of the selected menu to apply the correct animation class**
  const selectedIndex = menuList.indexOf(sini_data_mode);

  //global props
  const content =
    sini_data_mode === "Site Analysis" ? <PARENT_SINI /> : <SITE_SELECTION />;

  const is_has_access_sini = dispatch(
    is_user_get_access_by_license_key("license_sini_data")
  );

  return (
    <main>
      {/*
       ** The container class now dynamically adds 'option-1-active' or 'option-2-active'
       ** to tell the CSS where to position the slider.
       ** Other classes like 'two_container' and 'margin_bottom_extra' are kept.
       */}
      <div
        className={`menu_container option-${
          selectedIndex + 1
        }-active two_container margin_bottom grey_container`}
      >
        {menuList.map((dt, idx) => (
          <button
            key={idx}
            // ** The button class is now 'menu_button' and gets an 'active_menu' class
            // ** when selected. This is for changing the text color.
            className={`menu_button ${
              sini_data_mode === dt ? "active_menu" : ""
            }`}
            onClick={() => on_set_menu(dt)}
            data-mapid="siteAnalysis"
          >
            {dt}
          </button>
        ))}
      </div>
      {is_has_access_sini?.is_pass ? (
        content
      ) : (
        <div
          style={{
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BLOCKED {...is_has_access_sini} />
        </div>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  project: state.project,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  is_user_get_access_by_license_key,
  set_value_properties,
})(SINI_WRAPER);
